export const DotsPattern = () => {
  return (
    <svg
      className="dots-pattern"
      width="382"
      height="320"
      viewBox="0 0 382 320"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <mask
          id="mask0_8234_1041"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="382"
          height="320"
        >
          <ellipse
            cx="191"
            cy="160"
            rx="191"
            ry="160"
            transform="matrix(-1 0 0 1 382 0)"
            fill="url(#paint0_radial_8234_1041)"
          />
        </mask>
        <g mask="url(#mask0_8234_1041)">
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 84.3418)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 354.695 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 339.828 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 324.945 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 310.062 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 99.2188)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 354.695 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 354.695 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 354.695 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 354.695 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 339.828 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 339.828 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 339.828 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 339.828 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 324.945 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 324.945 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 324.945 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 324.945 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 310.062 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 310.062 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 310.062 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 310.062 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 295.172 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 280.289 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 265.406 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 250.531 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 235.641 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 220.766 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 205.867 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 190.992 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 176.125 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 161.219 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 146.352 248.053)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 131.461 248.053)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 116.578 248.053)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 101.695 248.053)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 86.8203 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 71.9219 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 57.0469 233.189)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 114.098)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 129.002)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 143.889)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 158.766)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 173.643)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 188.52)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 203.428)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 218.305)"
            fill="#D9D9D9"
          />
          <ellipse
            cx="2.48052"
            cy="2.4811"
            rx="2.48052"
            ry="2.4811"
            transform="matrix(-1 0 0 1 42.1641 233.189)"
            fill="#D9D9D9"
          />
        </g>
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_8234_1041"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(191 160) rotate(90) scale(160 191)"
        >
          <stop stopColor="white" stopOpacity="0.7" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
};
